import axiosIns from '@/plugins/axios'

export default {
  create() {
    return axiosIns.post('/admin/report_templates')
  },
}
